import type { CateringService } from '../services/cateringService';
import '../config/runtimeConfig';
import { officeMeetingService, type MeetingService } from '../services/meetingService';

export type Dependencies = {
  readonly cateringService?: CateringService;
  readonly meetingService: MeetingService;
};

export type ResolvedDependencies = Dependencies & {
  readonly cateringService: CateringService;
};

export function createRealDependencies(): Dependencies {
  return {
    meetingService: officeMeetingService,
  };
}

export async function createDependencies(): Promise<Dependencies> {
  // Keep this raw Vite expression so real builds can erase the mock import.
  if (import.meta.env.VITE_USE_MOCKS === 'true') {
    const { createMockDependencies } = await import('../mocks/mockDependencies');
    return createMockDependencies();
  }

  return createRealDependencies();
}
